import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export const ClicksChart = ({ data }) => (
  <div data-testid="clicks-chart" className="border border-[#211B10]/10 bg-white p-6 mb-12">
    <div className="flex items-center justify-between mb-6">
      <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#211B10]/60">
        Klik CTA — 14 Hari Terakhir
      </span>
      <span className="font-display text-2xl text-[#A67C1E]" data-testid="chart-total-clicks">
        {data.reduce((s, d) => s + d.clicks, 0)}
      </span>
    </div>
    <div className="h-56">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 4, right: 24, left: -20, bottom: 4 }}>
          <defs>
            <linearGradient id="goldFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#A67C1E" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#A67C1E" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="rgba(33,27,16,0.08)" vertical={false} />
          <XAxis
            dataKey="label"
            interval="preserveStartEnd"
            minTickGap={24}
            tickMargin={6}
            tick={{ fill: "rgba(33,27,16,0.4)", fontSize: 10, fontFamily: "JetBrains Mono" }}
            axisLine={{ stroke: "rgba(255,255,255,0.1)" }}
            tickLine={false}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fill: "rgba(33,27,16,0.4)", fontSize: 10, fontFamily: "JetBrains Mono" }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            contentStyle={{
              background: "#FFFFFF",
              border: "1px solid rgba(212,175,55,0.4)",
              borderRadius: 0,
              fontSize: 12,
              color: "#211B10",
            }}
            labelStyle={{ color: "rgba(33,27,16,0.5)", fontSize: 10 }}
            formatter={(value) => [value, "Klik"]}
          />
          <Area
            type="monotone"
            dataKey="clicks"
            stroke="#A67C1E"
            strokeWidth={2}
            fill="url(#goldFill)"
            dot={false}
            activeDot={{ r: 4, fill: "#A67C1E", stroke: "#FBF7EE" }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  </div>
);
